/**
 * Manière de dire une comparaison, selon la nature de ce qu'elle porte.
 *
 * Le même opérateur ne se lit pas de la même façon d'une nature à l'autre : `EQUALS` se dit « Est »
 * d'un statut ou d'un choix, « Égal » d'un nombre, « Le » d'une date. C'est le mot qui change,
 * jamais l'opérateur — le brouillon enregistre `EQUALS` dans les trois cas.
 */
export enum COMPARISON_WORDING {
    /** Ce qui est ou n'est pas : un statut d'indicateur, un choix, un genre, une langue. */
    STATE = 'STATE',

    /** Ce qui se compte et s'ordonne : les crans d'une échelle, le chiffre d'affaires. */
    NUMBER = 'NUMBER',

    /** Ce qui se situe dans le temps : une date de naissance, une date de contact. */
    DATE = 'DATE',
}
